import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      // padding: 10,
    },
    grow: {
      flexGrow: 1,
    },
    titleLayout: {
      padding: 20,
      backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
      color: 'white',
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    cardLayout: {},
  })
);

export default useStyles;
